import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

if (document.body.hasAttribute('data-admin')) {
    document.querySelectorAll('[data-admin-menu-item]').forEach((element) => {
        tippy(element, {
            content: element.textContent.trim(),
            placement: 'right',
            onShow: () => window.innerWidth < 768,
        });
    });

    document.querySelectorAll('form[method="POST"]').forEach((form) => {
        form.addEventListener('submit', (event) => {
            form.onsubmit = () => false;
        });
    });
}
